import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialState = {
  prescriptionId: null,
  selectedPainIndex: null,
  formValues: null,
  offlineSessionInitiated: false,
};

export const useSessionCheckInStore = create(
  persist(
    set => ({
      ...initialState,
      setSelectedPainIndex: index => set({ selectedPainIndex: index }),
      setFormValues: values => set({ formValues: values }),
      setPrescriptionId: id => set({ prescriptionId: id }),
      setOfflineSessionInitiated: value => set({ offlineSessionInitiated: value }),
      resetStore: () => set(initialState),
    }),
    {
      name: 'rehab-session-check-in',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
